import { ServiceWorkerCommunicationService, WindowEventType } from '@shared/extension';

export async function sendLatestDashboardMessage(serviceWorkerCommunicationService: ServiceWorkerCommunicationService) {
  const dashboardMessage = await serviceWorkerCommunicationService.getLatestDashboardMessage();
  if (!dashboardMessage) {
    return;
  }
  window.postMessage(
    { type: WindowEventType.FromDashboard, action: dashboardMessage.action, detail: dashboardMessage.detail },
    '*'
  );
}
